export type SeriesIssueInfo = {
  number: string;
  issuedAt: string;
};
